export default {

  sideBarItems: [
    {
      id: 3,
      collapsible: true,
      isOpen: false,
      defaultPosition: 'sidebar',
      componentName: "layouts-widget"
    },
    {
      id: 4,
      collapsible: true,
      isOpen: false,
      defaultPosition: 'sidebar',
      componentName: "tenants-widget",
    },
    {
      id: 5,
      collapsible: true,
      isOpen: false,
      defaultPosition: 'sidebar',
      componentName: "widgets-widget",
    },
    {
      id: 6,
      collapsible: true,
      isOpen: false,
      defaultPosition: 'sidebar',
      componentName: "views-widget",
    },
    {
      id: "video-tour-widget",
      collapsible: true,
      isOpen: false,
      defaultPosition: "sidebar",
      componentName: "video-tour-widget",
    },
    {
      id: 7,
      collapsible: false,
      isOpen: false,
      defaultPosition: 'sidebar',
      componentName: "scripts-widget",
    },
    {
      id: 8,
      collapsible: false,
      isOpen: false,
      defaultPosition: 'sidebar',
      componentName: "pages-widget",
    },
    {
      id: 10,
      collapsible: true,
      isOpen: false,
      defaultPosition: 'sidebar',
      componentName: "video-wall-widget",
    },
    {
      id: 'unit_groups_widget',
      collapsible: false,
      isOpen: false,
      defaultPosition: 'sidebar',
      componentName: "unit-groups-widget",
    },
    {
      id: 'user_charts_widget',
      collapsible: false,
      isOpen: false,
      defaultPosition: 'sidebar',
      componentName: "user-charts-widget",
    },
    {
      id: 'chat_widget',
      collapsible: false,
      isOpen: false,
      defaultPosition: 'sidebar',
      componentName: "chat-widget",
    },
  ],
  sideBarRightItems: [
    {
      id: 'in_review_alarms',
      title: "Alarmas en revisión",
      collapsible: true,
      isOpen: true,
      defaultPosition: 'sidebar',
      filters: { filter: 'in_review' },
      componentName: "alarms-widget",
    },
    {
      id: 'user_alarms',
      title: "Alarmas de usuario",
      collapsible: true,
      isOpen: true,
      defaultPosition: 'sidebar',
      filters: { filter: 'user_alarms' },
      componentName: "alarms-widget",
    },
    {
      id: 'in_maintenance_alarms',
      title: "Alarmas en falla",
      collapsible: true,
      isOpen: true,
      defaultPosition: 'sidebar',
      filters: { filter: 'in_maintenance' },
      componentName: "alarms-widget",
    },
    {
      id: 1,
      title: "Alarmas en espera",
      collapsible: true,
      isOpen: true,
      defaultPosition: 'sidebar',
      filters: { filter: 'waiting' },
      componentName: "alarms-widget",
    },
    {
      id: 2,
      title: "Alarmas en atención",
      collapsible: true,
      isOpen: true,
      defaultPosition: 'sidebar',
      filters: { filter: 'attending' },
      componentName: "alarms-widget",
    },
  ],
  bottomBarItems: [
  ],
};
